// Inhoudsopgave — fixed bottom-left "op deze pagina" drawer
import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", function () {
  const toc = document.querySelector(".inhoudsopgave");

  if (!toc) return;

  const tab = toc.querySelector(".inhoudsopgave__tab");
  const panel = toc.querySelector(".inhoudsopgave__panel");
  const DUR = 0.42;

  function open() {
    if (toc.dataset.state === "open") return;
    toc.dataset.state = "open";
    tab.setAttribute("aria-expanded", "true");

    // Reveal, then measure the natural height + padding for this viewport.
    panel.hidden = false;
    gsap.killTweensOf(panel);
    gsap.set(panel, { clearProps: "height,paddingTop,paddingBottom,overflow" });
    const cs = window.getComputedStyle(panel);
    const padTop = cs.paddingTop;
    const padBottom = cs.paddingBottom;
    const full = panel.offsetHeight;

    // Collapse height AND vertical padding together so it can reach a true 0.
    gsap.fromTo(
      panel,
      { height: 0, paddingTop: 0, paddingBottom: 0, overflow: "hidden" },
      {
        height: full,
        paddingTop: padTop,
        paddingBottom: padBottom,
        duration: DUR,
        ease: "power3.out",
        onComplete: () =>
          gsap.set(panel, {
            clearProps: "height,paddingTop,paddingBottom,overflow",
          }),
      },
    );
  }

  function close() {
    if (toc.dataset.state === "closed") return;
    toc.dataset.state = "closed";
    tab.setAttribute("aria-expanded", "false");

    gsap.killTweensOf(panel);
    const cs = window.getComputedStyle(panel);
    gsap.fromTo(
      panel,
      {
        height: panel.offsetHeight,
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
        overflow: "hidden",
      },
      {
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: DUR,
        ease: "power3.inOut",
        onComplete: () => {
          panel.hidden = true;
          gsap.set(panel, {
            clearProps: "height,paddingTop,paddingBottom,overflow",
          });
        },
      },
    );
  }

  function toggle() {
    if (toc.dataset.state === "open") {
      close();
    } else {
      open();
    }
  }

  tab.addEventListener("click", toggle);

  // Smooth scroll to the section, then close the drawer.
  toc.querySelectorAll(".inhoudsopgave__link").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute("href"));
      if (target) {
        window.scrollTo({
          top: target.offsetTop - 48,
          behavior: "smooth",
        });
      }
      close();
    });
  });

  // Close when clicking outside the drawer.
  document.addEventListener("click", (e) => {
    if (toc.dataset.state === "open" && !toc.contains(e.target)) {
      close();
    }
  });

  // Close on Escape.
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && toc.dataset.state === "open") {
      close();
    }
  });
});
